import { Config } from "src/app/config";
import { Library } from "./library";
import { Page } from "./page";
import { Menu } from "./menu";

export class Exam {
  id: number;
  name: string;
  description: string;
  order: number;
  enable: boolean;
  pageWidth: number;
  pageHeight: number;
  style: string;
  disableSubmit: boolean;
  currentPageIndex: number;
  library: Library;
  menu: Menu[];
  pages: Page[];

  constructor(exam: Exam = null) {
    if (exam == null) {
      this.id = -1;
      this.name = "New Exam";
      this.description = "";
      this.order = 0;
      this.enable = true;
      this.pageWidth = 1024;
      this.pageHeight = 768;
      this.style = Config.EffectiveStyle("");
      this.disableSubmit = false;
      this.library = new Library();
      this.menu = [];
      this.pages = [];
      let page = new Page();
      page.name = "Base Page";
      this.pages.push(page);
      this.currentPageIndex = 0;
    } else {
      this.id = exam.id;
      this.name = exam.name;
      this.description = exam.description;
      this.order = exam.order;
      this.enable = exam.enable;
      this.pageWidth = exam.pageWidth;
      this.pageHeight = exam.pageHeight;
      // A style this brand does not offer (every aerial, baton and tap exam stored as
      // aa-design-1) is shown in the brand's standard one, and a save stores that.
      this.style = Config.EffectiveStyle(exam.style);
      this.disableSubmit = exam.disableSubmit === undefined ? false : exam.disableSubmit;
      this.library = new Library(exam.library);
      this.menu = JSON.parse(JSON.stringify(exam.menu || []));
      this.pages = [];
      exam.pages.forEach(page => {
        let newPage = new Page(page, this.style);
        this.pages.push(newPage);
      });
      this.currentPageIndex = exam.currentPageIndex;
    }
  }

  checkPageNameInUse(name: string, exceptIndex: number = -1): boolean {
    for (let i = 0; i < this.pages.length; i++) {
      if (i != exceptIndex && this.pages[i].name == name) {
        return true;
      }
    }
    return false;
  }

  addPage(): void {
    let page = new Page();
    let num = 1;
    let found;
    do {
      found = false;
      page.name = "Page " + num;
      if (this.checkPageNameInUse(page.name)) {
        found = true;
      }
      num++;
    } while (found);

    this.pages.push(page);
  }

  duplicatePage(index: number): void {
    if (index < 0 || index >= this.pages.length) {
      return;
    }

    let newPage = new Page(this.pages[index]);
    let name = "Copy of " + this.pages[index].name;
    let num = 0;
    let found;
    do {
      found = false;
      newPage.name = name + (num > 0 ? " " + num : "");
      if (this.checkPageNameInUse(newPage.name)) {
        found = true;
      }
      num++;
    } while (found);

    this.pages.splice(index + 1, 0, newPage);
  }
}
